const STYLES = {
  pending: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  confirmed: "border-emerald-400/40 bg-emerald-400/10 text-emerald-300",
  completed: "border-sky-400/40 bg-sky-400/10 text-sky-300",
  cancelled: "border-red-400/40 bg-red-400/10 text-red-300",
  new: "border-amber-400/40 bg-amber-400/10 text-amber-300",
  read: "border-slate-400/30 bg-slate-400/10 text-slate-300",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs capitalize ${STYLES[status] || STYLES.read}`}>
    {status}
  </span>
);

export const ActionBtn = ({ children, onClick, testId, tone = "default", disabled }) => {
  const tones = {
    default: "border-[#D4AF37]/30 text-slate-200 hover:border-[#D4AF37] hover:text-white",
    gold: "border-[#D4AF37] bg-[#D4AF37] text-[#07040D] hover:bg-[#F3E5AB]",
    danger: "border-red-400/30 text-red-300 hover:border-red-400 hover:bg-red-400/10",
  };
  return (
    <button onClick={onClick} disabled={disabled} data-testid={testId}
      className={`inline-flex h-9 items-center gap-1.5 rounded-full border px-3.5 text-xs transition-colors disabled:opacity-40 ${tones[tone]}`}>
      {children}
    </button>
  );
};
